import React, { Component } from 'react';
import QRCode from 'qrcode.react';

class ProfileQrPanel extends Component {
  state = {
    freeTextInput: '',
    freeTextQrValue: '',
    freeTextQrError: null,
    freeTextQrSize: 180,
  };

  freeTextExportPngRef = React.createRef();
  freeTextExportSvgRef = React.createRef();

  handleFreeTextChange = (e) => {
    this.setState({ freeTextInput: e.target.value });
  };

  handleGenerateFreeTextQr = () => {
    const value = String(this.state.freeTextInput || '').trim();
    if (value) this.setState({ freeTextQrValue: value, freeTextQrError: null });
  };

  handleFreeTextQrSizeChange = (value) => {
    this.setState({ freeTextQrSize: Number(value) });
  };

  handleDownloadFreeTextPng = () => {
    const canvas = this.freeTextExportPngRef.current?.querySelector('canvas');
    if (!canvas) {
      this.setState({ freeTextQrError: 'Generate a QR code before downloading.' });
      return;
    }

    const link = document.createElement('a');
    link.download = 'storyclub-free-text-qr-3000px.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  handleDownloadFreeTextSvg = () => {
    const svgNode = this.freeTextExportSvgRef.current?.querySelector('svg');
    if (!svgNode) {
      this.setState({ freeTextQrError: 'Generate a QR code before downloading.' });
      return;
    }

    const serializer = new XMLSerializer();
    const svgText = serializer.serializeToString(svgNode);
    const blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.download = 'storyclub-free-text-qr.svg';
    link.href = blobUrl;
    link.click();

    URL.revokeObjectURL(blobUrl);
  };

  render() {
    const {
      qrTransparentBackground,
      fgColor,
      bgColor,
    } = this.props;

    const { freeTextInput, freeTextQrValue, freeTextQrError, freeTextQrSize } = this.state;

    return (
      <aside className="pf-grid__col pf-grid__col--side">
        <div className="pf-photo-placeholder" aria-label="Profile picture placeholder" role="img">
          <div className="pf-photo-placeholder__avatar">Photo</div>
          <p className="pf-photo-placeholder__text">Profile picture placeholder</p>
        </div>

        <div className="pf-public-url pf-free-text-qr">
          <h3 className="pf-public-url__title">Free Text QR Code</h3>
          <div className="pf-public-url__size-row">
            <label htmlFor="free-text-qr-input" className="pf-public-url__bg-label">Text / URL</label>
            <div className="pf-public-url__size-control">
              <input
                id="free-text-qr-input"
                type="text"
                className="pf-input"
                placeholder="Any text or URL"
                value={freeTextInput}
                onChange={this.handleFreeTextChange}
                onKeyDown={(e) => e.key === 'Enter' && this.handleGenerateFreeTextQr()}
              />
            </div>
          </div>
          <button
            type="button"
            className="pf-btn dark pf-btn--qr-compact"
            onClick={this.handleGenerateFreeTextQr}
            disabled={!freeTextInput.trim()}
          >
            Generate QR
          </button>

          <div className="pf-public-url__size-row">
            <label htmlFor="free-text-qr-size-slider" className="pf-public-url__bg-label">QR size</label>
            <div className="pf-public-url__size-control">
              <input
                id="free-text-qr-size-slider"
                type="range"
                min="72"
                max="420"
                step="2"
                value={freeTextQrSize}
                onChange={(e) => this.handleFreeTextQrSizeChange(e.target.value)}
                aria-label="Free text QR preview size"
              />
              <span className="pf-public-url__size-value">{freeTextQrSize}px</span>
            </div>
          </div>

          {freeTextQrValue && (
            <div className="pf-public-url__preview">
              <div className={`pf-public-url__qr ${qrTransparentBackground ? 'is-transparent-bg' : ''}`}>
                <QRCode
                  value={freeTextQrValue}
                  size={freeTextQrSize}
                  level="L"
                  includeMargin={false}
                  fgColor={fgColor}
                  bgColor={bgColor}
                />
              </div>
              <div className="pf-public-url__exports" aria-hidden="true">
                <div ref={this.freeTextExportPngRef}>
                  <QRCode
                    value={freeTextQrValue}
                    size={3000}
                    level="L"
                    includeMargin={false}
                    fgColor={fgColor}
                    bgColor={bgColor}
                  />
                </div>
                <div ref={this.freeTextExportSvgRef}>
                  <QRCode
                    value={freeTextQrValue}
                    size={1200}
                    level="L"
                    includeMargin={false}
                    renderAs="svg"
                    fgColor={fgColor}
                    bgColor={bgColor}
                  />
                </div>
              </div>
              <p className="pf-public-url__hint">{freeTextQrValue}</p>
              <button
                type="button"
                className="pf-btn dark"
                onClick={this.handleDownloadFreeTextPng}
              >
                Download QR PNG (3000px)
              </button>
              <button
                type="button"
                className="pf-btn dark"
                onClick={this.handleDownloadFreeTextSvg}
              >
                Download QR SVG
              </button>
              {freeTextQrError && <div className="pf-error">{freeTextQrError}</div>}
            </div>
          )}
        </div>
      </aside>
    );
  }
}

export default ProfileQrPanel;
